<app-loader></app-loader>
<div class="app-container">
  <main>
    <!--
      `<app-tutorial-card>` was removed here by `tasks/announcements.md` Phase F7. The tutorial
      engine it belonged to was withdrawn for drifting from what it was meant to do, and the
      element was the last thing left that could paint over the announcement dialog.
    -->
    <router-outlet></router-outlet>
  </main>
  <footer>
    <p>&copy; {{year}}<span class="hide-mobile"> MedicAI. All rights reserved.</span> |
      <a href="assets/documents/IQject Terms of service - v0.5.pdf" target="_blank">Terms</a> |
      <a href="assets/documents/IQject privacy notice - 21 January 2025.pdf" target="_blank">Privacy</a> |
      <!-- <a href="assets/documents/IQject Access to information notice - v0.4.pdf" target="_blank"><span class="hide-mobile">Information </span>Access</a> | -->
      <a href="assets/documents/InfoRegSA-PAIA-Form02-Reg7.pdf" target="_blank"><span class="hide-mobile">Information </span>Access</a> |
      <!-- <a [routerLink]="['/policy-viewer']" [queryParams]="{ type: 'popia' }"><span class="hide-mobile">PAIA &
        </span>POPIA</a> | -->
      <a (click)="openContactDialog($event)" href="#">Contact<span class="hide-mobile"> Us</span></a> |
      <span class="hide-mobile">Version: </span>{{appVersion}}
    </p>
  </footer>
</div>

<ng-template #contactDialog>
  <h1 mat-dialog-title>Contact Us</h1>
  <div mat-dialog-content>
    <!-- Wrapped in a form so the required validators on the fields below aggregate into a single
         validity flag the Send button can gate on. Without this the controls are standalone
         ngModels and nothing knows whether the form as a whole is complete. -->
    <form #contactForm="ngForm" class="p-t-20 field-column">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Title</mat-label>
        <mat-select name="title" [(ngModel)]="contactMessage.title" required>
          <mat-option *ngFor="let title of titles" [value]="title.value">
            {{ title.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Name</mat-label>
        <input matInput name="name" [(ngModel)]="contactMessage.name" placeholder="Name" type="text" required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Surname</mat-label>
        <input matInput name="surname" [(ngModel)]="contactMessage.surname" placeholder="Surname" type="text"
          required>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput name="email" [(ngModel)]="contactMessage.email" placeholder="Email" type="email" required
          email>
        <mat-error *ngIf="contactForm.controls['email']?.hasError('email')">Please enter a valid email</mat-error>
      </mat-form-field>
      <!-- Bound to `phone`: that is the field the server destructures (contactController.js:21).
           This was bound to `contactNumber`, which the server ignores, so the number never arrived. -->
      <app-intl-phone-input [preferredCountries]="['za']" [providedValue]="contactMessage.phone"
        placeholder="Contact Number" (valueChange)="contactMessage.phone = $event" name="phone"
        classList="full-width"></app-intl-phone-input>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Message</mat-label>
        <textarea matInput name="message" [(ngModel)]="contactMessage.message" rows="4" required></textarea>
      </mat-form-field>

      <!-- Honeypot: hidden from real users; bots that fill it are silently dropped server-side. -->
      <input type="text" name="company" autocomplete="off" tabindex="-1" aria-hidden="true"
        [(ngModel)]="contactMessage.company"
        style="position:absolute; left:-9999px; width:1px; height:1px; opacity:0;">

      <!-- Cloudflare Turnstile challenge (rendered when TURNSTILE_SITE_KEY is configured). -->
      <app-turnstile (tokenChange)="contactMessage.turnstileToken = $event"></app-turnstile>
    </form>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" (click)="sendContactMessage(contactForm)"
      [disabled]="contactForm.invalid || !contactChallengeReady">Send</button>
  </div>

</ng-template>